<template>
  <div
    class="select custom"
    :class="{'open': isOpenSelect}"
  >
    <div
      class="select-element"
      @click="selectHandler"
    >
      <span v-html="selectTitle"></span>
      <img
        src="~/assets/img/svg/common/arrow-down.svg"
        alt="стрелка фильтра вниз"
      >
    </div>

    <template v-if="isOpenSelect">
      <div class="select-dropdown">
        <template
          v-for="(option,id) in selectList"
          :key="`select-dropdown-itm-${id}`"
        >
          <div
            class="select-dropdown-row"
            :class="{'select-dropdown-row__callback': usageStyleSelectForCallback}"
            @click="() => changeSort(option)"
          >
            <span>{{ option[labelName] }}</span>
            <span
              v-if="option?.price !== undefined "
              class="select-dropdown-row__extra-val"
            >{{ $priceFormat({amount: option?.price, decimalCount: 0}) }} ₽</span>
          </div>
        </template>
      </div>
      <div
        class="select-overlay"
        @click="selectHandler"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
const { selectList = [], activeValue = 'Выбрать', labelName = 'name', valueType = '', formType = '' } = defineProps<{

	selectList?: Array<any>;
	activeValue?: string;
	labelName?: string;
  valueType?: string | null; // костыль для тайтла
  formType?: string | null;
}>();
const emits = defineEmits<{
	emitOptions: [options: any]
}>();
const { $priceFormat } = useNuxtApp();
const isOpenSelect = ref<boolean>(false);

const selectHandler = () => {
  isOpenSelect.value = !isOpenSelect.value;
};

const changeSort = (options: any) => {
  emits('emitOptions', options);
  selectHandler();
};

const selectTitle = computed(() => {
  if (valueType && activeValue === 'Выбрать') {
    return valueType
  } else {
    return activeValue
  }
})

const usageStyleSelectForCallback = computed(() => {
  return formType === 'Свяжитесь с нами'
})
</script>

<style lang="scss">
:root {
	--select-dropdown-border: var(--smoky-white);
	--select-main-boder-color: var(--smoky-white);
	--select-element-bg: var(--gray);
}

.select {
	&.open.custom {
		z-index: 26;

    & > .select-element {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
	}
}

.select-element {
	padding: 8px 44px 8px 24px;
	height: var(--input-height);
	border-radius: var(--input-border-radius);
	border: var(--input-border);
	color: var(--black);
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	display: flex;
	align-items: center;
	transition: all .2s linear;
	position: relative;
	z-index: 24;
  &.open {
    border-radius: 16px 16px 0 0;
  }

	&:hover {
		border-color: var(--text-secondary-silver);
	}

	& > span {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	& img {
		top: 20px;
		right: 24px;
		filter: none;
	}
}

.select-dropdown {
	top: calc(60% + 5px);
	z-index: 21;
	border-radius: 16px;

	& > div:first-child {
		padding-top: 22px;
	}

	& > div {
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		padding: 10px 24px;

	}
}

.select-dropdown-row {
	display: flex;
	justify-content: space-between;

  &.select-dropdown-row__callback {
    padding: 12px 22px!important;
    &:first-child {
      padding-top: 30px!important;
    }
    &:hover {
      background: #ebebeb59;
    }

    & > span {
      color: #000;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
    }
  }
}

</style>
